document.addEventListener('click', function(e) {
    if (e.target.closest('.rating-star')) {
        e.preventDefault();

        const reviewSection = document.querySelector('#judgeme_product_reviews');
        
        if (reviewSection) {
            const offset = 100;
            const position = reviewSection.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({
                top: position,
                behavior: 'smooth'
            });
        }
    }
});